const boldFileP = `${process.env.REACT_APP_BASE_CDN}/static/media/OpelNextBold.woff2`;
const lightFileP = `${process.env.REACT_APP_BASE_CDN}/static/media/OpelNextLight.woff2`;
const regularFileP = `${process.env.REACT_APP_BASE_CDN}/static/media/OpelNextRegular.woff2`;

const boldFileS = `${process.env.REACT_APP_BASE_CDN}/static/media/PSAGroupeHMISans-Bold.woff2`;
const lightFileS = `${process.env.REACT_APP_BASE_CDN}/static/media/PSAGroupeHMISans-Light.woff2`;
const normalFileS = `${process.env.REACT_APP_BASE_CDN}/static/media/PSAGroupeHMISans-Regular.woff2`;

export default {
  primary: {
    bold: { file: boldFileP, name: 'Opel Next Bold' },
    lighter: { file: lightFileP, name: 'Opel Next Lighter' },
    normal: { file: regularFileP, name: 'Opel Next' }
  },
  secondary: {
    bold: {
      file: boldFileS,
      name: 'PSA Groupe HMI Sans Bold'
    },
    lighter: {
      file: lightFileS,
      name: 'PSA Groupe HMI Sans Lighter'
    },
    normal: {
      file: normalFileS,
      name: 'PSA Groupe HMI Sans'
    }
  }
};
